import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Clipboard from 'v-clipboard'
import Storage from 'vue-ls'
import UserActions from './plugins/user-actions.js'
import VueScrollTo from 'vue-scrollto'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/pt-br';
import VueGtm from '@gtm-support/vue2-gtm';

import ICS from 'vue-ics'
 
/** VUE TOASTS **/
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';


// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/fonts/icomoon/style.css'
import './assets/sass/agenda.scss'

Vue.config.productionTip = false

Vue.use(VueToast)
Vue.use(VueMoment, { moment })
Vue.moment().locale('pt-br')

Vue.use(ICS)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Copy to Clipboard plugin
Vue.use(Clipboard)

// Scroll To elementos
Vue.use(VueScrollTo)

// Local Storage plugin
Vue.use(Storage);

// Funções do usuário
Vue.use(UserActions);


// Configurando o GTM
Vue.use(VueGtm, {
  id: "GTM-K47SVHP", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
